<template>
    <div class="app-inner" id="previewCourse" style="padding:0px !important; margin:0px"
     v-loading="Allloading"
    element-loading-text="加载中～～～"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    >
            <div class="pay-info" >
                <div class="thumb-example flex">
                     <div class="preview-wrap">
                        <img :src="list.logo" alt="">
                     </div>
                     <div class="itemInfo-wrap mft">
                          <div class="info flex align-cen">
                            <div class="label">课程名称</div>
                            <div class="info-con" style="width:80%">{{ list.title }}</div>
                        </div>
                        <div class="info flex align-cen">
                            <div class="label">课程描述</div>
                            <div class="info-con" style="width:80%">{{list.introduction}}</div>
                        </div>
                         <div class="info flex align-cen">
                            <div class="label">课程更新</div>
                            <div class="info-con" style="width:80%">{{list.chapterNum}}期</div>
                        </div>
                           <!-- <div class="info flex align-cen" v-if="list.payType ==  2 && userinfo">
                              <div class="label">开通企业</div>
                              <div class="info-con">
                                <el-select v-model="value" placeholder="请选择"
                                @change="dataSuccess"
                                >
                                  <el-option
                                    v-for="(item, index) in options"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id"
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </div> -->
                            <div class="info flex align-cen" v-if="list.payType == 2 && businessInfo">
                              <div class="label">联系电话</div>
                              <div class="info-con" style="width:80%">{{phone}}</div>
                            </div>
                            <div class="info flex align-cen" v-if="list.payType == 2 &&  list.isAuth == 1">
                              <div class="label">到期时间</div>
                              <div class="info-con" style="width:80%">{{list.timeLimit == 0 ?  list.endTime : '无限制时间' }}</div>
                            </div>
                         <div class="info flex align-cen" v-if="list.payType == 1">
                            <div class="label">选购方式</div>
                            <div class="info-con" style="color:red;width:80%" >免费</div>
                        </div>
                         <div class="info" v-if="list.payType == 2 && list.isAuth == 0">
            <div class="label">选购方案</div>
            <div class="info-con">
              <div class="ace-tab-goods-card">
                <div class="sku-goods-wrap">
                  <div class="sku-goods-grid">
                    <div
                      class="
                        ace-row ace-row-wrap
                        sku-goods-row
                        goods-simple-row
                      "
                    >
                      <div
                        class="ace-col ace-col-6 sku-goods-col-simple"
                        v-for="(item, index) in list.skuList"
                        :key="index"
                      >
                        <div
                          class="goods-card-simple"
                          :class="{ current: active == index }"
                             @click="checkSku(item, index)"
                       
                        >
                          <div class="simple-card-header">
                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                            <div class="simple-header-title">
                              {{ item.name }}
                            </div>
                            </el-tooltip>
                          </div>
                          <div class="simple-content-form">
                            <div class="ace-form ace-medium">
                              <div class="form-item-list flex align-cen">
                                <div class="ace-form-item-label ace-left">
                                  账号个数
                                </div>
                                <div class="ace-form-item-label ace-right">
                                  {{ item.accountNum || "无限制" }}
                                </div>
                              </div>
                              <div class="form-item-list flex align-cen">
                                <div class="ace-form-item-label ace-left">
                                  使用期限(月)
                                </div>
                                <div class="ace-form-item-label ace-right">
                                  {{ item.deadline || "无限期" }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="simple-price-box">
                            <div class="right-price-box">
                              <div class="price-content price-content1 flex">
                                 <div class="price-label">原价：</div>
                                <div class="price-icon">¥</div>
                                <div class="price-trade">
                                  {{ item.originalPrice }}
                                </div>
                              </div>
                              <div class="price-content flex">
                                 <div class="price-label">现价：</div>
                                <div
                                  class="price-icon"
                                  style="margin-right: 5px"
                                >
                                  ¥
                                </div>
                                <div class="price-trade">
                                  {{ item.salePrice }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                          </div>
                         <div class="info flex align-cen" v-if="list.payType == 2 && list.isAuth == 0">
             <el-button type="primary"  class="public-btn-small-primary public-btn-small-load btn" 
              @click="creatOrder"
            >
               立即购买
           </el-button>
          </div>
                     </div>
                </div>
            </div>
            <div class="pay-contaniner">
                  <div class="ace-dbl-nav-channel"
            >
                <div class="mod">
                <div class="inner flex align-cen">
                <div class="nav-text"
                 v-for="(item,index) in titleList"
                :key="index"
                :class="{ active: currentNav1 == index }"
                @click="toBox1(index)"
                >{{item.title}}</div>
                </div>
                </div>
            </div>
            <div class="corsedet"  v-if="currentNav1 == 0" style="margin-top:10px;background: #fff;">
             <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }"
            >
                <div class="mod">
                <div class="inner flex align-cen">
                <div class="nav-text"
                 v-for="(item,index) in list.contentList"
                :key="index"
                :class="{ active: currentNav == index }"
                @click="toBox(index)"
                >{{item.title}}</div>
                </div>
                </div>
            </div>
                 <div class="scene j-content" 
                      v-for="(item,index) in list.contentList"
                    :key="index"
             >
                  <div class="quedior">
                        <h2>{{item.title}}</h2>
                        <div class="subtitle ">{{item.subhead}}</div>
                        <div v-html="item.content" class="nr" v-if="!$util.isMobile()"></div>
                        <div v-html="item.mobileContent ? item.mobileContent : item.content" class="nr" v-if="$util.isMobile()"></div>
                    </div>
             </div>
            </div>
             <div class="corseDet" v-if="currentNav1 == 1" style="margin-top:10px;background: #fff;padding: 0 10px;">
                          <div class="helpChapter-con-tit flex align-cen">
                <div class="tit-ribbon">
                    共{{total}}章
                </div>
            </div>
                  <div class="chapter-list" v-if="list.chapterList && list.chapterList.length">
                    <el-collapse v-model="activeNames">
                        <el-collapse-item v-for="(item,index) in list.chapterList" :key="item.id"  :name="item.id">
                            <template slot="title">
                                <div class="numlist-tit flex align-cen">
                                    <div class="tit-name">
                                        {{item.serialNum}} {{item.name}}
                                    </div>
                                </div>
                            </template>
                            <div v-for="(childItem,childIndex) in item.children" :key="childItem.id" class="childrenlist flex align-cen">
                               <div class="childrenlist-tit">
                                 {{childItem.serialNum}} {{childItem.name}}
                               </div>
                               <div class="mft childrenlist-btn flex align-cen" @click="openVideo(childItem,index,childIndex)" >
                                      <el-tooltip class="item" effect="dark" content="试听课" placement="top-start" v-if="childItem.trial == 1">
                                        <i class="icon-al-playcircle"  style="color:#409eff"></i>
                                        </el-tooltip>
                                        <span v-if="childItem.trial == 1" style="color:#409eff"> 试听课</span>
                                        <el-tooltip class="item" effect="dark" content="学习课程" placement="top-start" v-if="childItem.trial != 1">
                                        <i class="icon-al-playcircle"  style="color:#409eff"></i>
                                        </el-tooltip>
                               </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="none-chapter" v-else>
                    <i class="icon-al-cry-fill"></i>
                    <p>暂无章节</p>
                </div>
             </div>
             <div class="corsedet" v-if="currentNav1 == 2">
                <div class="exams-main">
                    <div class="exams-panel-body">
                                                <div class="table-toolbar flex align-cen">
                            <div class="table-toolbar-left flex align-cen">
                                <div class="now-exam btnexam" :class="textActive == '0' ? 'btnactive' : ''" @click="swichTopic(0)">正式考试</div>
                                <div class="log-exam btnexam" :class="textActive == '1' ? 'btnactive' : ''" @click="swichTopic(1)">练习考试</div>
                            </div>
                            <div class="table-toolbar-right mft flex align-cen">
                                <div class="regulaOption">
                                    <el-select v-model="regulaTagValue"  clearable placeholder="考试状态"
                                   @change="getcenChan"
                                    >
                                        <el-option
                                        v-for="item in regulaTag"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.state">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                           <div class="exams-list">
                                   <div class="onlineExam" >
                                  <div class="public-tit flex align-cen" style="margin:10px 16px">
                                    <div class="public-tit-list">
                                        <i class="icon-al-file-fill"></i>  课程关联试卷
                                    </div>
                                </div>
                                   <div class="exams-scrollbar flex" v-if="paperList.length">
                                 <!-- -->
                                <div class="exams-item" v-for="(item,index) in paperList" >
                                    <div class="exams-item-paperName">
                                        {{item.paperName}}
                                    </div>
                                    <div class="exams-item-info flex">
                                        <img :src="item.logo" alt="" class="trmubimg">
                                        <div class="exams-item-info-rule">
                                            <div>
                                            <p v-if="item.validPeriod == '2'" class="flex">考试时间：<span class="mft">永久有效</span></p>
                                            <p v-if="item.validPeriod == '1'" class="flex">考试时间：
                                                <el-tooltip class="item" effect="dark" :content="`${item.showFromTime}~${item.showUntilTime}`" placement="top"> 
                                                <span class="mft">
                                                    {{item.showFromTime}}~{{item.showUntilTime}}
                                                </span>
                                               </el-tooltip>
                                            </p>
                                           <p class="flex align-cen">考试次数：
                                            <span class="mft">
                                                {{getAanswerNumType(item.answerNumType,item.answerNum,1)}}
                                            </span>
                                           </p>
                                           <p class="flex">
                                            考试限时:
                                            <span class="mft" v-if="item.validPeriod == '2'">{{item.timeLimit}}分钟</span>
                                            <span class="mft" v-else>-</span>
                                           </p>
                                           <p class="flex">
                                            考试总分:
                                            <span class="mft">{{item.paperScore}}分</span>
                                           </p>
                                           <p class="flex">
                                            及格分数:
                                            <span class="mft">{{item.passmark}}%</span>
                                           </p>
                                           </div>
                                     <div class="tipImg">
                                        <img src="../../assets/images/examNow.png" alt="" v-if="item.state == '1'" class="jxz">
                                         <img src="../../assets/images/examno.png" alt="" v-if="item.state == '0'">
                                          <img src="../../assets/images/examend.png" alt="" v-if="item.state == '2'">

                                    </div>
                                        </div>
                                    </div>
                                    <div class="exams-item-line"></div>
                                    <div class="flex" style="justify-content:end">
                                        <div class="exams-item-btn" v-if="item.state == 1" @click="openExamlogin(item)">进入考试</div>
                                         <div class="exams-item-btn exams-item-btn1" v-if="item.state == 2">已考完</div>
                                          <div class="exams-item-btn exams-item-btn1" v-if="item.state == 0">未开始</div>
                                    </div>
                                </div>
                            </div>
                            <div class="exams-scrollbar" v-else>
                                <el-empty>
                            </el-empty>
                            </div>
                                   </div>
                            </div>
                    </div>
                </div>
             </div>
            </div>
        </div>
</template>
<script>
import {courseDetail,enPaperList,editOrder} from "@/api/enterprise/index"  //获取课程详情、关联试卷列表
import debounce from '../../utils/debounce.js' //防抖
export default {
    name:'',
    data() {
        return {
          Allloading:false,
          contentTopList:[],
          loading:false,
          value:'',
          businessName:'',
          phone:'',
          options:[],
            userinfo:{},
            businessInfo:{},
            textActive:0,
            practiceMode:'0',
            state:'',
            total:0,
            paperList:[],
            activeNames:[],
            isClick:false,
            tabPosition:'top',
            isFixed: false,
             currentNav:0,
             currentNav1:0,
            list:{},
            priceInfo:{},
             current: "current",
            active: "",
            regulaTagValue:'',
              regulaTag:[
                 {
                    state:'',
                    name:'全部'
                },
                {
                    state:'0',
                    name:'未开始'
                },
                {
                    state:'1',
                    name:'考试中'
                }, {
                    state:'2',
                    name:'已结束'
                },
            ],
            titleList:[
                {
                    id:1,
                    title:'课程详情',
                },
                {
                    id:2,
                    title:'课程目录',
                },
                {
                    id:3,
                    title:'课程关联试卷',
                },
            ]
        }
    },
    created() {
        this.userinfo =  this.$locaStorage.setAge().get('userinfo1')
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        if(this.businessInfo) this.phone = this.businessInfo.phone
        if(!this.businessInfo &&  this.userinfo)  this.goBuess()
        this.getList() 
        this.getPapercouList()
        this.currentNav1 = this.$route.query.currentNav1 || 0
    },
       mounted() {
       window.addEventListener('scroll', this.handleScroll) // 监听滑动事件
  },
    methods: {
      // 跳转登录
      goLogin(){
                     this.$router.push({
            name:'enHlyhLogin',
            query: {
               redirectUrl:'HlrjenCourseDetail',
               id:this.$route.query.id,
               currentNav1:this.currentNav1
            }
         })
      },
      // 选择企业
      goBuess(){
           this.$router.push({
            name:'HlrjenBusiness',
            query: {
               id:this.$route.query.id,
               currentNav1:this.currentNav1
            }
         })
      },
       // 创建订单
    creatOrder(){
      if(!this.userinfo){
        this.goLogin()
      }else if(!this.businessInfo){
        this.goBuess()
      }
      else{
        let dataJson = {
            id:this.$route.query.id,
            index:this.active,
            data:this.priceInfo
           }
          this.$router.push({
            name:'HlrjenCourseCreateOrder',
            query: {
               dataJson : this.$base64.encode(JSON.stringify(dataJson))
            }
         })

      //  this.loading = true
      //   let params = {
      //       orderType:'2',
      //       appId:this.priceInfo.courseId,
      //       appSkuId:this.priceInfo.id,
      //       businessId:this.businessInfo.id,
      //       orderAmount:this.priceInfo.salePrice,
      //       officialType:'1'
      //    }
      //      editOrder(params,'post','enterprise')
      //   .then(res =>{
      //      this.loading = false
      //       if(res.code == 0){
      //          this.$util.Notifi('订单提交成功','success','fa-check'); 
      //           setTimeout(() => {
      //                this.$router.push({
      //           name:'buyOrder',
      //           query:{
      //               id:res.data
      //           }
      //       })
      //            }, 100);
      //       }else{
      //           this.loading = false
      //           this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
      //       }
      //   })
      //   .catch(err =>{
      //       this.loading = false
      //       this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
      //   })
      }
    },
       // 开通企业切换
    // dataSuccess(e){
    //    let newarr = this.options.filter(item => item.id ==e)
    //     this.phone = newarr[0].phone
    // },
    //       getEnBusinee() {
    //   enBusiness({}, "enterprise")
    //     .then((res) => {
    //       this.options = res.data;
    //       this.value = res.data[0].id;
    //       this.businessName = res.data[0].name
    //       this.phone = res.data[0].phone
    //     })
    //     .catch((err) => {
    //     });
    // },
           // 打开进入考试
        openExamlogin(data){
          if(!this.userinfo){
            this.goLogin()
          }else if(!this.businessInfo){
            this.goBuess()
          }else{
            const newurl = this.$router.resolve({name: 'examLogin', query: {id: data.paperId,businessId:this.businessInfo.id}})
       window.open(newurl.href,'_blank')
          }
           
        },
        getcenChan(){
            this.state = this.regulaTagValue
         this.getPapercouList()
        },
           swichTopic(index){
            this.textActive = index
            this.practiceMode = index
            this.getPapercouList()
        },
        // 获取关联试卷
        getPapercouList(){
            enPaperList({id:this.$route.query.id,state:this.state,practiceMode:this.practiceMode})
            .then(res =>{
                this.paperList = res.data
            })
        },
        // 打开试听课
        openVideo(data,index,childIndex){
          if(!this.userinfo){
            this.goLogin()
          }else if(!this.businessInfo){
            this.goBuess()
          }
          else{
            const newurl = this.$router.resolve({name:'HlrjenCourseVideo',
             query: {id: this.$route.query.id,
             chapterId:data.id,
             title:this.list.title,
             index:index,
             childIndex:childIndex
             }})
             window.open(newurl.href,'_blank')
            //    this.$router.push(
            //     {
            //         name:'enCourseVideo',
            //         query:{
            //             id:this.$route.query.id,
            //             chapterId:data.id,
                        
            //         }
            //     }
            // )
          }
        },
            // 点击tab
    toBox(index) {
    // 点击滚动到指定的位置，要去掉滚动的过程中因为位置变化带来的效果
      this.isClick = true
      this.currentNav = index
      const DOM = index >=0 ? document.querySelectorAll('.j-content')[index] : document.querySelectorAll('.j-content1')[0]
      const offsetTop = DOM.offsetTop - 50
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      })
       // 过一段时间，把isClick还原
      setTimeout(() => {
        this.isClick = false
      }, 800)
    },
            // 点击tab
    toBox1(index) {
      this.currentNav1 = index
    },
           // 选择规格
    checkSku(data, i) {
      this.active = i;
      this.priceInfo = data
    },
        getList(){
          this.Allloading = true
           courseDetail({id:this.$route.query.id,accountId:this.userinfo ? this.userinfo.id : '' ,businessId:this.businessInfo ? this.businessInfo.id  : ''}) 
           .then(res =>{
           this.Allloading = false
           this.list = res.data
           this.priceInfo = res.data.skuList[0]
           if(res.data.chapterList && res.data.chapterList.length){
            this.total = res.data.chapterList.length || 0
                     for (const key in res.data.chapterList) {
                        this.activeNames.push(res.data.chapterList[key].id)
                    }
                    }
                            this.$nextTick(() =>{  
                 if(this.$route.query.currentNav1){
                  this.currentNav1 = this.$route.query.currentNav1
                  var  offsetTop = document.querySelector('.pay-info').offsetHeight
                window.scrollTo({
                  top: offsetTop,
                  behavior: 'smooth'
                })
                }
        })
           })
           .catch(err =>{this.Allloading = false})
        },
                // 处理滚动
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      var offsetTop 
      if(this.$route.query.type != 3) offsetTop = document.querySelector('.pay-info').offsetHeight
    //   if(this.$route.query.type == 3) offsetTop = 0
       // 获取所有锚点元素
      const divs = [...document.querySelectorAll('.j-content')]
      // 将所有锚点元素offsetTop push到数组内
      divs.forEach((item, index) => {
        this.contentTopList[index] = item.offsetTop - 50
      })
       // 判断当前是否是点击定位的，如果不是，才有滚动定位的效果
      if (!this.isClick) {
        let navIndex
        // 滚动定位tab高亮的状态
        for (let i = 0; i < this.contentTopList.length; i++) {
          // 如果当前滚动的top坐标大于第i个的top坐标，就记录下i。记录到最后，i就会是最后一个满足条件的i，也就是刚刚好的那个值
          if (scrollTop >= this.contentTopList[i]) {
            navIndex = i
          }
        }
        // 把下标赋值给 vue 的 data
        this.currentNav = navIndex
        if (typeof navIndex !== 'number') {
            this.currentNav = 0
          
        }
      }
      // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
         
    },
        // 获取考试次数
        getAanswerNumType(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示题型判断
            const actionTypelanes = {
                0:'无限次',
                1:fnType == 1 ? '一次' : fnType == 2 ? '单选题' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '多选题' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? '判断题' : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || ''
        },
    },
       destroyed() {
    window.removeEventListener('scroll', this.handleScroll) // 销毁监听滑动事件
  },
}
</script>
<style lang="scss" scoped>
#previewCourse{
    position: relative;
    height: 100vh;
}
.exams-main{
    height: inherit;
    .exams-panel-body{
            position: relative;
            .table-toolbar{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 52px;
                margin-bottom: 0;
                padding: 0 16px;
                box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.1);
                z-index: 10;
                margin-bottom: 16px !important;
                .table-toolbar-left{
                    .btnexam{
                    height: 36px;
                    line-height: 36px;
                    padding: 0px 18px;
                    border-radius: 4px!important;
                    text-decoration: none!important;
                    white-space: nowrap;
                    cursor: pointer;
                     border: 1px solid #e4e4e4;
                    color: #36aafd;
                    border-color: #36aafd;
                    box-sizing: border-box;
                    line-height: 36px;
                    margin-right: 20px;
                    }
                    .btnactive{
                        background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%)!important;
                        color: #fff !important;
                    }
                }
                  .regulaOption{
                    width: 120px;
                    margin-right: 20px;
                  }
            }
            .exams-list{
                position: relative;
                .exams-scrollbar{
                    padding: 0 16px;
                    justify-content: space-between;
                        flex-wrap: wrap;
                    .exams-item{
                        margin-bottom: 16px;
                        padding: 16px 24px;
                        border-radius: 3px;
                        border: solid 1px #e6e6e6;
                        width: 44%;
                        position: relative;
                       .exams-item-paperName{
                        line-height: 30px;
                        margin: 0 16px 0 0;
                        font-size: 20px;
                        font-weight: 700;
                        color: #333!important;
                        transition: color 0.3s;
                        cursor: pointer;
                        word-break: break-all;
                       }
                       .exams-item-info{
                        margin: 10px 0;
                        img{
                            width: 220px;
                            height: 140px;
                        }
                        .exams-item-info-rule{
                            flex: 1;
                            padding: 0 15px;
                            color: #999;
                            width: calc(100% - 220px);
                            position: relative;
                            p{
                                margin-bottom: 10px;
                                padding-bottom: 5px;
                                border-bottom: 1px solid #e6e6e6;
                                 white-space: nowrap;  
                                overflow: hidden;  
                                text-overflow: ellipsis;
                            }
                            .tipImg{
                                position: absolute;
                                top: 25px;
                                left: 50%;
                                transform: translateX(-50%);
                                img{
                                  width: 154px;
                                  height: 122px;
                                transform: rotate(-45deg); 
                                
                                }
                                .jxz{
                                         width: 84px;
                                  height: 82px;
                                transform: rotate(-45deg); 
                                opacity: .2;
                                }
                            }
                        }
                       }
                       .exams-item-line{
                          border-bottom: 1px solid #e6e6e6;
                       }
                       .exams-item-btn{
                        background-image: linear-gradient(60deg, #36c0fd 0%, #3672fd 100%) !important;
                        color: #fff;
                        height: 36px;
                        padding: 0px 18px;
                        border-radius: 4px !important;
                        text-decoration: none !important;
                        white-space: nowrap;
                        cursor: pointer;
                        border: 1px solid #e4e4e4;
                        box-sizing: border-box;
                        line-height: 36px;
                        margin-right: 20px;
                        width: 120px;
                        text-align: center;
                        margin: 20px 0 0 0;
                       }
                       .exams-item-btn1{
                         background-image: linear-gradient(60deg, #e6e6e6 0%, #e6e6e6 100%) !important;
                         color: #999;
                       }
                    }
                             .exams-item:hover{
            border: 1px solid #36aafd;
        }
                }
            }
        }
}
  .pay-info {
    max-width: 1210px;
    min-height: 560px;
    margin: 0 auto;
    .thumb-example {
      background-color: transparent;
      .preview-wrap {
        width: 373px;
        height: 280px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
      }
      .gallery-top {
        width: 100%;
        .swiper-slide {
          min-height: 300px;
        }
      }
      .gallery-thumbs {
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 10px;
        justify-content: space-between;
      }
      .gallery-thumbs .swiper-slide {
        width: 80px;
        height: 50px;
        opacity: 0.4;
        margin-right: 5px !important;
      }
      .gallery-thumbs .swiper-slide-active {
        opacity: 1;
        border: 2px solid #e53e41;
        box-sizing: border-box;
      }
    }
    .itemInfo-wrap {
      width: calc(1210px - 452px);
      margin-left: 30px;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
      padding: 20px;
      .info {
        padding-bottom: 10px;
        .btn{
            height: 32px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 16px;
    border-radius: 2px;
    font-family: inherit;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
    cursor: pointer;
    transition: all 0.3s;
    background: #409eff;
    color: #fff;
        }
        .label {
         font: 700 16px Arial, "microsoft yahei";
          color: #999;
          width: 120px;
        }
        .info-con {
          font-size: 13px;
          color: #666;
          margin-bottom: 5px;
          .ace-tab-goods-card {
            padding: 20px 0 10px;
            box-sizing: border-box;
            margin: 0 auto;
            width: 100%;
            padding-top: 0;
            .sku-goods-wrap {
              min-height: 220px;
              transition: all 0.3s;
              .goods-simple-row {
                padding: 5px 0;
                margin: 0 -10px;
                flex-wrap: wrap;
                display: flex;
                .sku-goods-col-simple {
                  padding: 5px 10px;
                  box-sizing: border-box;
                  flex: 0 0 33%;
                  width: 33%;
                  max-width: 33%;
                  .current {
                    border: 1px solid #e53e41 !important;
                  }
                  .goods-card-simple {
                    cursor: pointer;
                    background: #fff;
                    position: relative;
                    border: 1px solid #ededec;
                    transition: box-shadow 0.3s ease-out;
                    .simple-card-header {
                      padding: 0 20px 10px;
                      padding-top: 28px;
                      box-sizing: border-box;
                      background: rgb(235, 236, 236);
                      .simple-header-title {
                        position: relative;
                        text-align: left;
                        font-size: 18px;
                        color: #181818;
                        letter-spacing: 0.55px;
                        line-height: 30px;
                        margin-bottom: 8px;
                        font-weight: 600;
                        transition: all 0.3s;
                         display: -webkit-box;
                              margin-bottom: 12px;
                              overflow: hidden;
                              -webkit-box-orient: vertical;
                              -webkit-line-clamp: 1;
                      }
                    }
                    .simple-content-form {
                      padding: 8px 20px;
                      box-sizing: border-box;
                      .ace-medium {
                        width: 100%;
                        .form-item-list {
                          box-sizing: border-box;
                          margin-bottom: 3px;
                          .ace-form-item-label {
                            font-size: 14px;
                            padding-right: 0;
                            display: inline-block;
                            vertical-align: top;
                            color: #999;
                          }
                          .ace-right {
                            padding-left: 40px;
                            color: #3d3d3d;
                          }
                        }
                      }
                    }
                    .simple-price-box {
                      padding: 0 20px;
                      box-sizing: border-box;
                      border-top: 1px solid #ebecec;
                      .simple-show-label {
                        margin-top: 12px;
                        margin-bottom: 12px;

                        .tag-item-text {
                          background: #155bd4;
                          border-radius: 2px;
                          text-align: left;
                          font-size: 12px;
                          color: #fff;
                          letter-spacing: 0.46px;
                          display: inline-block;
                          padding: 2px 12px;
                          line-height: 20px;
                          margin-right: 8px;
                        }
                      }
                      .right-price-box {
                        margin-bottom: 14px;
                        margin-top: 20px;
                        .price-content {
                          font-size: 14px;
                          .price-icon {
                            color: #ea3a3a;
                            letter-spacing: 0.81px;
                          }
                          .price-trade {
                            text-align: left;
                            color: #ea3a3a;
                            letter-spacing: 1.2px;
                          }
                        }
                        .price-content1 {
                          margin-right: 20px;
                          .price-icon,
                          .price-trade {
                            color: #999;
                            text-decoration: line-through;
                          }
                        }
                      }
                    }
                    .buy-button-box {
                      width: 100%;
                      height: 36px;
                      text-align: center;
                      line-height: 36px;
                      color: #fff;
                      background: #ea3a3a;
                      cursor: pointer;
                    }
                  }
                  .goods-card-simple:hover {
                    box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
   .pay-contaniner{
    margin-bottom: 60px;
      background-color: rgb(249, 249, 249);
      .ace-dbl-nav-channel{
        height: 50px;
        position: relative;
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
    .inner{
        max-width: 1280px;
        margin: 0 auto;
        height: 50px;
        justify-content: center;
        .nav-text{
            vertical-align: middle;
            height: 50px;
            line-height: 50px;
            font-size: 14px;
            margin-right: 50px;
            font-weight: 400;
            font-stretch: normal;
            letter-spacing: 0;
            color: #181818;
            cursor: pointer;
        }
        .active{
            color: #155bd4;
            border-bottom: 3px solid #155bd4;
        }
    }
      }
      .fixed{
         position: fixed;
        top: 0px;
        left: 0;
        right: 0;
        z-index: 10;

      }
      .j-content{
        max-width: 100%;
        width: 100%;
        margin: 0 auto;
        padding: 50px 0px 10px;
        h2{
        font-size: 32px;
        color: rgb(24, 24, 24);
        line-height: 42px;
        margin-bottom: 12px;
         position: relative;
         text-align: center;
         font-weight: bold;
        }
        .subtitle {
            font-size: 16px;
    color: #333;
    line-height: 24px;
     text-align: center;
     padding-bottom: 10px;
        }
      }
      .j-content1{
         width: 100%;
         max-width: 100%;
         padding: 0px;
         .ace-tab-goods-card{
                padding: 20px 0 50px;
                box-sizing: border-box;
                margin: 0 auto;
                width: 1200px;
            .sku-goods-wrap{
                min-height: 220px;
                transition: all .3s;
                .goods-simple-row{
                 padding: 5px 0;
                 margin: 0 -10px;
                 flex-wrap: wrap;
                 display: flex;
                 .sku-goods-col-simple{
                        padding: 5px 10px;
                    box-sizing: border-box;
                        flex: 0 0 25%;
                    width: 25%;
                    max-width: 25%;
                    .goods-card-simple{
                        background: #fff;
                        position: relative;
                        border: 1px solid #ededec;
                        transition: box-shadow .3s ease-out;
                        .simple-card-header {
                            padding: 0 20px 10px;
                            padding-top: 28px;
                            box-sizing: border-box;
                            background: rgb(235, 236, 236);
                            .simple-header-title{
                                position: relative;
                                text-align: left;
                                font-size: 18px;
                                color: #181818;
                                letter-spacing: .55px;
                                line-height: 30px;
                                margin-bottom: 8px;
                                font-weight: 600;
                                transition: all .3s;
                                 display: -webkit-box;
                              margin-bottom: 12px;
                              overflow: hidden;
                              -webkit-box-orient: vertical;
                              -webkit-line-clamp: 1;
                            }
                        }
                        .simple-content-form {
                            padding: 8px 20px;
                            box-sizing: border-box;
                            .ace-medium{
                                width: 100%;
                                .form-item-list{
                                    box-sizing: border-box;
                                    margin-bottom: 3px;
                                    .ace-form-item-label {
                                        font-size: 14px;
                                        padding-right: 0;
                                            display: inline-block;
                                            vertical-align: top;
                                            color: #999;
                                    }
                                    .ace-right{
                                       padding-left: 40px;
                                        color: #3d3d3d;
                                    }
                                }
                            }
                        }
                        .simple-price-box {
                            padding: 0 20px;
                            box-sizing: border-box;
                            border-top: 1px solid #ebecec;
                            .simple-show-label{
                                    margin-top: 12px;
                                    margin-bottom: 12px;
                                   
                                    .tag-item-text{
                                        background:  #155bd4;
                                    border-radius: 2px;
                                    text-align: left;
                                    font-size: 12px;
                                    color: #fff;
                                    letter-spacing: .46px;
                                    display: inline-block;
                                    padding: 2px 12px;
                                    line-height: 20px;
                                    margin-right: 8px;
                                    }
                            }
                            .right-price-box{
                                    margin-bottom: 14px;
                                   margin-top: 20px;
                             .price-content{
                                margin-bottom: 4px;
                                .price-icon{
                                    color: #ea3a3a;
                                    font-size: 16px;
                                    letter-spacing: .81px;
                                }
                                .price-trade{
                                        text-align: left;
                                    color: #ea3a3a;
                                    line-height: 26px;
                                    font-size: 24px;
                                    letter-spacing: 1.2px;
                                }
                             }
                             .price-content1{
                                margin-right: 20px;
                                .price-icon,.price-trade{color: #999; text-decoration: line-through;}
                             }
                            }
                        }
                        .buy-button-box{
                            width: 100%;
                            height: 36px;
                            text-align: center;
                            line-height: 36px;
                            color: #fff;
                            background: #ea3a3a;
                            cursor: pointer;
                        }
                    }
                    .goods-card-simple:hover{
                        box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
                    }
                 }
                }
            }
         }
      }
    }
      .numlist-tit{
            padding: 0 14px;
            font-size: 16px;
            width: 100%;
            .mft{
                font-size: 13px;
                color: rgb(21, 91, 212);
                div{
                    cursor: pointer;
                    position: relative;
                }
                div:not(:last-child)::after{
                    content: "|";
                   color: #e5e5e5;
                   padding: 0 5px;
                }
                
            }
          }
        .helpChapter-con-tit{
            padding: 10px 12px;
            margin-top: 20px;
            position: relative;
            .tit-ribbon{
                padding-left: 8px;
            }
            .tit-ribbon::before{
                content: '';
                background-color: #155bd4;
                width: 3px;
                height: 14px;
                position: absolute;
                top: 18px;
                left: 12px;
            }
          }
             .none-chapter{
            text-align: center;
            padding-top: 100px;
            i{
                font-size: 50px;
               
            }
          }
              .childrenlist{
            padding: 10px 30px;
            margin-top: 10px;
            background: #f7f8fa;
            .childrenlist-tit{
                font-size: 14px;
            }
            .childrenlist-btn{
                padding-right: 5px;
              i{
                 margin-right: 10px;
                  font-size: 20px;
                  cursor: pointer;
              }
            }
          }
::v-deep{
    .el-collapse-item__wrap{
        border-bottom: none;
    }
}
@media (max-width: 640px){
#previewCourse{
  .pay-info{
              margin-top: -56px !important;
    .thumb-example{
      display: block;
      .preview-wrap{
        width: 100%;
        img{
          width: 100%;
          max-height:280px ;
        }
      }
      .itemInfo-wrap{
        width: auto;
        margin: 20px;
         .goods-simple-row{
            display: block !important;
            .sku-goods-col-simple{
              width: 100% !important;
              max-width: 100% !important;
            }
          }
      }
    }
  }
                .exams-scrollbar{
            display: block !important;
            .exams-item{
                  width: auto !important;
                  .exams-item-info{
                    .trmubimg{
                      width: 110px;
                      height: 80px;
                    }
                  }
            }
          }
     .ace-dbl-nav-channel{
            .inner{
                max-width: 100% !important;
                .nav-text{
                    margin-right: 0 !important;
                    padding: 0 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
}
}
</style>